import { render } from "./Vip.vue?vue&type=template&id=14ba9f0d&scoped=true"
import script from "./Vip.vue?vue&type=script&lang=js"
export * from "./Vip.vue?vue&type=script&lang=js"

import "./Vip.vue?vue&type=style&index=0&id=14ba9f0d&lang=css"
import "./Vip.vue?vue&type=style&index=1&id=14ba9f0d&scoped=true&lang=css"

import exportComponent from "E:\\work\\copy\\work\\fa\\tgkw\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14ba9f0d"]])

export default __exports__